import get from 'lodash/get';
import { combineReducers } from 'redux';
import { createReducer } from 'redux-act';
import { createSelector, createSelectorCreator, lruMemoize } from 'reselect';
import shallowequal from 'shallowequal';
import { createResource } from '@gandi/resource/redux';
import { baseUrl as moduleBaseUrl, hashString, statePath as moduleStatePath } from '../utils';
export const statePath = `${moduleStatePath}.regions`;
export const baseUrl = `${moduleBaseUrl}/regions`;
export const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 50;
export const DEFAULT_SORT_BY = 'date_created';
export const defaultParams = {
  page: DEFAULT_PAGE,
  per_page: DEFAULT_PER_PAGE,
  sort_by: DEFAULT_SORT_BY
};
export const computeLabel = params => hashString(JSON.stringify({
  ...defaultParams,
  ...params
}));
export const resourceName = 'resources-simplehosting.regions';
export const resource = createResource(resourceName);
export const fetch = (params = {}, options = {}) => dispatch => {
  const mergedParams = {
    ...defaultParams,
    ...params
  };
  const label = computeLabel(mergedParams);
  return dispatch(resource.fetch(baseUrl, {
    label,
    params: mergedParams,
    ...options
  }));
};
export const invalidate = () => dispatch => dispatch(resource.invalidate());
export const initialState = {
  summaries: {
    data: {}
  }
};
export const handleFetchSuccess = (state, payload) => ({
  ...state,
  data: payload.response.data.reduce((old, current) => ({
    ...old,
    [current.id]: current
  }), state.data),
  [payload.label]: {
    ids: payload.response.data.map(item => item.id),
    totalCount: parseInt(payload.response.headers.get('x-total-count'), 10)
  }
});
export const summariesReducer = createReducer({
  [resource.fetch.success.getType()]: handleFetchSuccess
}, initialState.summaries);
export const reducer = combineReducers({
  summaries: summariesReducer
});
const selectRawState = state => get(state, statePath, initialState);
export const selectRawSummaries = state => selectRawState(state).summaries;
export const selectSummariesData = state => selectRawSummaries(state).data;
const createShallowEqualSelector = createSelectorCreator(lruMemoize, shallowequal);
export const selectComputedLabel = createShallowEqualSelector([selectRawSummaries, (_, props) => computeLabel(props || defaultParams)], (raw, label) => label);
export const selectSummariesMeta = createSelector([selectRawSummaries, selectComputedLabel], (raw, label) => raw ? raw[label] : undefined);
export const selectSummariesTotalCount = createSelector([selectSummariesMeta], meta => meta ? meta.totalCount : undefined);
export const selectSummaries = createSelector([selectSummariesData, selectSummariesMeta], (data, meta) => meta ? meta.ids.map(id => get(data, id)).filter(Boolean) : undefined);
export const selectIsFetching = (state, props) => resource.selectIsFetching(state, selectComputedLabel(state, props));
export const selectIsLoaded = (state, props) => resource.selectIsLoaded(state, selectComputedLabel(state, props));
export const selectIsFailure = (state, props) => resource.selectIsFailure(state, selectComputedLabel(state, props));
export const selectIsForbidden = (state, props) => resource.selectIsFailure(state, {
  label: selectComputedLabel(state, props),
  status: 403
});
export const selectIsToRefetch = (state, props) => resource.selectIsToRefetch(state, selectComputedLabel(state, props));